<app-card [cardOptionBtnValue]="'admin.localization.overview.purge'|translate" [cardOptionBtn]="true" [cardRouterLink]="null" (outputButton)="purgeTranslations()" [title]="'global.overview'|translate">
  <app-grid #gridView [grid]="grid" ></app-grid>

  <app-modal-basic #editAllModal [hideOnClickOutside]="false">
    <div class="app-modal-header">
      <h4 class="modal-title">Modal title</h4>
      <button type="button" class="close basic-close" (click)="editAllModal.hide()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="app-modal-body" *ngIf="adjust">
      <div class="pb-4">Adjust: <b>{{adjust.domain.name}}.{{ adjust.keyword }}</b></div>

      <ng-container *ngFor="let tr of translations">        <div class="form-group form-horizontal">
          <label>{{tr.language.locale}}</label>
          <input type="text" class="form-control" [(ngModel)]="tr.value">
        </div>
      </ng-container>
    </div>
    <div class="app-modal-footer">
      <button type="button" class="btn btn-default ripple" (click)="editAllModal.hide()">Close</button>
      <button type="button" class="btn btn-primary ripple light" (click)="saveAllModal()" >Save changes</button>
    </div>
  </app-modal-basic>

</app-card>
